import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { HttpRequestQueueService } from '../services/http-request-queue.service';
import { ApiHolder } from '../classes/api-holder';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
    const httpRequestQueueService = inject(HttpRequestQueueService);
    req = setBearerAuthorizationHeader(req);
    if (isRefreshTokenRequest(req)) {
        return next(req);
    } else {
        return next(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === HttpStatusCode.Unauthorized) {
                    return httpRequestQueueService.handle401Error().pipe(
                        switchMap(() => next(setBearerAuthorizationHeader(req)))
                    );
                } else {
                    return throwError(() => error);
                }
            })
        );
    }
};

const isRefreshTokenRequest: (req: HttpRequest<unknown>) => boolean = (req: HttpRequest<unknown>) => {
    const baseApiUrl = environment.apiUrl;
    const refreshTokenRelativeUrl = ApiHolder.account.refreshToken().relativeUrl;
    return req.url === `${baseApiUrl}${refreshTokenRelativeUrl}`;
};

const setBearerAuthorizationHeader: (req: HttpRequest<unknown>) => HttpRequest<unknown> = (req: HttpRequest<unknown>) => {
    let accessToken = localStorage.getItem("accessToken");
    if(accessToken && isApiRequest(req)) {
        req = req.clone({
            setHeaders: { 'Authorization': 'Bearer ' + accessToken}
        });
    }
    return req;
}

const isApiRequest: (req: HttpRequest<unknown>) => boolean = (req: HttpRequest<unknown>) => req.url.startsWith(environment.apiUrl);
